import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import find from 'lodash/find'
import set from 'lodash/set'
import get from 'lodash/get'
import orderBy from 'lodash/orderBy'
import Select from 'react-select'
import { Button, Label } from 'reactstrap'
import { timesheetAction, lobAction } from '../../../../actions'
import { timesheetSelector, lobSelector } from '../../../../selectors'
import ExportByProjectForm from '../../form/export-timesheet-by-project'
import ExportByLOBForm from '../../form/export-timesheet-by-lob'
import * as timesheetHelper from '../../helpers/timesheet'
import { customStyles, invalidStyles } from '../../helpers/color'
import { FONTS } from '../../../../constants'
import moment from '../../../../lib/moment.js'

const TimesheetByProjectButton = class extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'getLOBData')) {
      const lobList = timesheetHelper.createLOBList(get(nextProps, 'getLOBData'))
      set(tempState, 'lobList', lobList)
      nextProps.resetGetLOB()
    }
    if (get(nextProps, 'projects')
    && get(nextProps, 'authData')
    && prevState.lobList.length !== 0
    && prevState.projectList.length === 0) {
      const lobID = get(nextProps, 'authData.user.lob_id')
      const defaultLOB = find(prevState.lobList, { value: lobID })
      const projectList = timesheetHelper.createProjectList(get(nextProps, 'projects'))
      const defaultProject = find(projectList, { value: get(nextProps, 'selectedIDProjects') })
      set(tempState, 'defaultLOB', defaultLOB || [])
      set(tempState, 'projectList', projectList)
      set(tempState, 'defaultProject', defaultProject || [])
      set(tempState, 'selectedProject', defaultProject || [])
      set(tempState, 'selectedLOB', defaultLOB)
    }
    if (get(nextProps, 'getExportURL')) {
      window.open(get(nextProps, 'getExportURL'))
      nextProps.resetExportTimesheet()
    }
    if (get(nextProps, 'selectedDateProjects') !== prevState.selectedDateProjects) {
      set(tempState, 'selectedDateProjects', get(nextProps, 'selectedDateProjects'))
      set(tempState, 'selectedStartMonth', moment(get(nextProps, 'selectedDateProjects')))
      set(tempState, 'selectedEndMonth', moment(get(nextProps, 'selectedDateProjects')))
    }
    return tempState
  }

  state={
    lobList: [],
    showExport: false,
    selectedProject: [],
    selectedLOB: [],
    projectList: [],
    selectedStartMonth: moment(),
    selectedEndMonth: moment(),
  }

  componentDidMount() {
    this.props.getLOB(localStorage.getItem('access_token'))
  }

  handleExport = (type) => {
    switch (type) {
      case 'project':
        return this.setState({
          showExportProject: !this.state.showExportProject,
          projectList: [],
          selectedProject: this.state.defaultProject,
          selectedStartMonth: moment(get(this.props, 'selectedDateProjects')),
          selectedEndMonth: moment(get(this.props, 'selectedDateProjects')),
        })
      case 'lob':
        return this.setState({
          showExportLOB: !this.state.showExportLOB,
          selectedLOB: this.state.defaultLOB,
          selectedStartMonth: moment(get(this.props, 'selectedDateProjects')),
          selectedEndMonth: moment(get(this.props, 'selectedDateProjects')),
        })
      default: return this.setState({
        showExportProject: false,
        showExportLOB: false,
        projectList: [],
      })
    }
  }

  handleInputExport = (type, data) => {
    switch (type) {
      case 'startDate': {
        this.setState({ selectedStartMonth: data })
        break
      }
      case 'endDate': {
        this.setState({ selectedEndMonth: data })
        break
      }
      case 'project': {
        this.setState({ selectedProject: data })
        break
      }
      case 'lob': {
        this.setState({ selectedLOB: data })
        break
      }
      default:
        break
    }
  }

  clickExportButton = (type) => {
    const access_token = localStorage.getItem('access_token')
    const {
      selectedProject,
      selectedLOB,
      selectedStartMonth,
      selectedEndMonth,
    } = this.state
    switch (type) {
      case 'project': {
        this.props.exportTimesheetByProject(
          selectedProject.value,
          moment(selectedStartMonth).format('YYYY-MM'),
          moment(selectedEndMonth).format('YYYY-MM'),
          access_token
        )
        break
      }
      case 'lob': {
        this.props.exportTimesheetByLOB(
          selectedLOB.value,
          moment(selectedStartMonth).format('YYYY-MM'),
          moment(selectedEndMonth).format('YYYY-MM'),
          access_token
        )
        break
      }
      default: break
    }
    this.handleExport()
    this.setState({ selectedProject: [], selectedLOB: [] })
  }

  render() {
    const { projects, selectedIDProjects } = this.props
    const { handleInputTimesheetByProjects } = this.props
    const projectList = timesheetHelper.createProjectList(projects)
    const project = find(projectList, { value: selectedIDProjects })
    const selectedDateProjects = get(this.props, 'selectedDateProjects')

    const IsAdminUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')
    const IsLOBLeadUser = get(this.props, 'authData.user.is_lob_lead_role')
    const IsAccountantUser = get(this.props, 'authData.user.is_accountant_role')
    const canExportByLOB = (IsAdminUser
      || IsSystemUser
      || IsHRConfidentialUser
      || IsManagementUser
      || IsAccountantUser)

    return (
      <Buttons>
        <SelectInputField
          styles={ project ? customStyles : invalidStyles }
          placeholder="- Choose Project -"
          options={ orderBy(projectList, 'label', 'asc') }
          onChange={ (e) => handleInputTimesheetByProjects('select_project', e) }
          value={ project }
        />
        <DateGroup>
          <ArrowButton
            background='white'
            onClick={ () => handleInputTimesheetByProjects('select_date', moment(selectedDateProjects.add(-1, 'month'))) }
          >&#65308;</ArrowButton>
          <LabelMonth>{ selectedDateProjects.format('MMM') } { selectedDateProjects.format('YYYY') }</LabelMonth>
          <ArrowButton
            background='white'
            onClick={ () => handleInputTimesheetByProjects('select_date', moment(selectedDateProjects.add(1, 'month'))) }
          >&#65310;</ArrowButton>
        </DateGroup>
        <ExportLabel>Export By:</ExportLabel>
        <ExportButton onClick={ () => this.handleExport('project') }>
          <ExportWrapper>
          Project
          </ExportWrapper>
        </ExportButton>
        { (canExportByLOB || IsLOBLeadUser) &&
        <ExportButton onClick={ () => this.handleExport('lob') }>
          <ExportWrapper>
          LOB
          </ExportWrapper>
        </ExportButton>
        }
        <ExportByProjectForm
          selectedProject={ this.state.selectedProject }
          selectedStartMonth={ this.state.selectedStartMonth }
          selectedEndMonth={ this.state.selectedEndMonth }
          projectList={ projectList }
          open={ this.state.showExportProject }
          toggle={ this.handleExport }
          handleInputExport={ this.handleInputExport }
          clickExportButton={ () => this.clickExportButton('project') }
        />
        <ExportByLOBForm
          selectedLOB={ this.state.selectedLOB }
          selectedStartMonth={ this.state.selectedStartMonth }
          selectedEndMonth={ this.state.selectedEndMonth }
          lobList={ this.state.lobList }
          open={ this.state.showExportLOB }
          toggle={ this.handleExport }
          handleInputExport={ this.handleInputExport }
          clickExportButton={ () => this.clickExportButton('lob') }
        />
      </Buttons>
    )
  }
}

TimesheetByProjectButton.propTypes = {
  projects: PropTypes.array,
  selectedIDProjects: PropTypes.string,
  exportTimesheetByProject: PropTypes.func.isRequired,
  exportTimesheetByLOB: PropTypes.func.isRequired,
  handleInputTimesheetByProjects: PropTypes.func,
  getLOB: PropTypes.func.isRequired,
}
TimesheetByProjectButton.defaultProps = {
  projects: [],
  selectedIDProjects: '',
  selectedDateProjects: '',
  handleInputTimesheetByProjects: () => {},
}

const mapStateToProps = (state, props) => createStructuredSelector({
  getExportURL: timesheetSelector.getExportURL,
  getLOBData: lobSelector.getListLOB,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  exportTimesheetByProject: timesheetAction.exportTimesheetByProject,
  exportTimesheetByLOB: timesheetAction.exportTimesheetByLOB,
  resetExportTimesheet: timesheetAction.resetExportTimesheet,
  getLOB: lobAction.getLOB,
  resetGetLOB: lobAction.resetListLOB,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(TimesheetByProjectButton)

const ExportLabel = styled(Label)`
  margin: 10px;
  font-size: 12px;
  width: 70px;
`
const Buttons = styled.div`
  justify-content: flex-end;
  position: absolute;
  display: flex;
  right: 10px;
  height: 40px;
  align-items: center;
`
const SelectInputField = styled(Select)`
  font-family: ${FONTS.GOTHAM} !important;
  width : 220px;
  font-size: ${FONTS.SMALL_SIZE};
  margin-right: 10px;
`
const ExportButton = styled.button`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  background-color: #428BCA;
  width: 80px;
  height: 30px;
  margin-right: 10px;
  color: white;
  border-color: #428BCA;
  border-radius: 4px;
  cursor: pointer;
  padding-bottom: 0px !important;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC ;
    }
`
const ExportWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`
const DateGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: auto;
  margin-bottom: auto;
`
const NavBarButton = styled(Button)`
  height: 30px;
  width: 70px;
  font-size: ${FONTS.SMALL_SIZE};
  margin-left: 2px;
  margin-right: 2px;
  padding: 0px;
  text-align: center;
  background: ${(props) => { return props.background }};
  color: ${(props) => { return props.color }};
  border: 1px solid #E6E6E6;
`
const ArrowButton = styled(NavBarButton)`
  width: 30px;
  color: black;
  font-size: ${FONTS.SMALL_SIZE};
  border: 1px solid #E6E6E6;
`
const LabelMonth = styled.label`
  width: 70px;
  font-size: ${FONTS.SMALL_SIZE};
  margin-top: auto;
  margin-bottom: auto;
  text-align: center;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab/button-group/timesheet-by-projects-button.js